/*eslint-disable*/
import React from "react";
import AdminNavbar from "components/Navbars/AdminNavbar.js";
import heroImg from "assets/img/maplist_show.png";
import PricingSection from "components/Pricing/PricingSection";
import FeaturesSection from "components/Features/FeaturesSection";
import Testimonials from "components/Testimonials/Testimonials";

export default function Index() {

  return (
    <>

      <AdminNavbar fixed lightBackground={false} />

      <section className="header relative pt-16 items-center flex flex-col md:flex-row h-screen">
        <div className="absolute inset-0 bg-primary"
        ></div>
        <div className="container z-4 mx-auto overflow-hidden flex flex-col h-full">
          <div className="container z-2 px-4 w-full items-center flex flex-wrap h-full justify-center text-center">
            <div className="pt-6 pb-6">
              <h1 className="text-4xl md:text-6xl font-semibold text-secondary">
                Create Google Maps Lists from Threads
              </h1>
              <p className="mt-8 text-xl md:text-3xl leading-relaxed text-secondary font-semibold">
                Mention @maplistbot in a Twitter thread to generate a Google Maps List
              </p>
              <div className="pt-12">
                <a
                  href="#pro"
                  className="text-primary font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-secondary uppercase text-sm shadow hover:shadow-lg ease-linear transition-all duration-150"
                >
                  <i className="fas fa-rocket mr-2"></i>
                  Get Pro
                </a>
                <a
                  href="/discover"
                  className="ml-1 text-white border border-solid border-white hover:text-white font-bold px-6 py-4 rounded outline-none focus:outline-none mr-1 mb-1 bg-transparent active:bg-blueGray-600 uppercase text-sm hover:shadow ease-linear transition-all duration-150"
                >
                  Discover Lists
                </a>
              </div>
            </div>
          </div>
          <div className="relative w-full h-full px-4 flex items-center justify-content">
            <div className="container z-4 mx-auto flex items-center justify-center">
              <img src={heroImg} alt="..." className="max-h-60vh" />
            </div>
          </div>
        </div>

      </section>

      <Testimonials />

      <section id='pro' className="bg-gray-50 dark:bg-gray-900 flex min-h-screen items-center">
        <FeaturesSection />
      </section>

      <PricingSection />

    </>
  );
}
